import { useState } from "react";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { setUsuario } from "../../Usuario/actions/actions";
import { save } from "../../Instituicao/api-instituicao";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import SettingsCard from "../SettingsCard";

const OPCOES = [
  {
    name: "comunicadoAprovacao",
    label: "Aprovação de comunicados",
    description: "Comunicados precisam ser aprovados por um administrador ou coordenador antes do envio.",
  },
  {
    name: "smsLembreteHabilitado",
    label: "SMS de lembrete",
    description: "Habilita o envio de SMS de lembrete do financeiro.",
  },
  {
    name: "smsPendenciaHabilitado",
    label: "SMS de pendência",
    description: "Habilita o envio de SMS de pendência do financeiro.",
  },
];

const PlataformaCard = () => {
  const usuario = useSelector((state) => state.usuario);
  const dispatch = useDispatch();
  const [savingName, setSavingName] = useState(null);
  const instituicao = usuario.instituicao;

  const handleSwitchChange = (name) => {
    setSavingName(name);
    save({ ...instituicao, [name]: !instituicao[name] })
      .then((data) => {
        if (!data) return;
        if (data.error) {
          errorMessage(data.message);
          return;
        }
        dispatch(setUsuario({ ...usuario, instituicao: data }));
      })
      .finally(() => setSavingName(null));
  };

  return (
    <SettingsCard
      title="Plataforma"
      description="Recursos habilitados para a instituição."
      contentPadding={false}
    >
      <Stack divider={<Divider />}>
        {OPCOES.map(({ name, label, description }) => (
          <Stack key={name} direction="row" alignItems="center" spacing={2} px={2.5} py={1.5}>
            <Stack flexGrow={1} minWidth={0}>
              <Typography variant="body2" fontWeight={500} component="label" htmlFor={`switch-${name}`}>
                {label}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {description}
              </Typography>
            </Stack>
            <Switch
              id={`switch-${name}`}
              checked={Boolean(instituicao[name])}
              disabled={savingName !== null}
              onChange={() => handleSwitchChange(name)}
            />
          </Stack>
        ))}
      </Stack>
    </SettingsCard>
  );
};

export default PlataformaCard;
